import React, { FunctionComponent } from 'react';

import styles from './ServiceCard.module.scss';
import ServiceCardActionBar from './ServiceCardActionBar';

interface ServiceCardProps {
  services: DrainDownAdditionalService[];
  name: string;
  description?: string;
  selectedExtras: DrainDownSelectedAdditionalService[];
  handleChange: (data: DrainDownSelectedAdditionalService) => void;
}

const ServiceCard: FunctionComponent<ServiceCardProps> = ({
  services,
  name,
  description,
  selectedExtras,
  handleChange,
}) => {
  return (
    <div className={styles.card}>
      <h2 className="owners-heading-2">{name}</h2>
      <div
        className="owners-body"
        dangerouslySetInnerHTML={{
          __html: description as string,
        }}
      ></div>
      {services.map((s) => (
        <div key={`action-${s.tag}`}>
          <hr />
          <ServiceCardActionBar
            service={s}
            quantity={
              selectedExtras.find((se) => se.service.tag === s.tag)?.quantity ||
              0
            }
            handleChange={handleChange}
          />
        </div>
      ))}
    </div>
  );
};

export default ServiceCard;
